import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';

import { getMainSearchContent } from '~/actions/search';

import TextLoader from '~/components/Loaders/TextLoader';
import { Icon } from '~/components';

import Interests from '~/components/Interests/Add';

import ArticleResult from './components/ArticleResult';


class Search extends React.Component {
    static propTypes = {
		session: PropTypes.object
	};

    state = {
        searched: false
    };

    componentDidMount() {
		ReactDOM.findDOMNode(this.refs.search).focus(); 
	}

    search = (e) => {
		e.preventDefault();
		this.setState({
			searched: true
		})
		this.props.getMainSearchContent( this.refs.search.value );
	};

    divider = (text) => {
		return <div className="search-divider clearfix">
        	<hr />
        	{ text > "" && <p>{text}</p> }
    	</div>
	};

    resultRow = (post) => {
		switch(post.post_type.slug) {
			case 'articles': 	return <ArticleResult {...post} key={'search-item-'+post.ID} />
		}
	};

    render() {

		let articles = this.props.search.articles,
			ideal_split = 4,
			split = articles.length >= ideal_split ? ideal_split : articles.length;

		return (
			<div className="mtop100">
				<div className="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
					<div className="search-form">
						<form onSubmit={this.search} method>
							<input  placeholder="Search..."
									ref="search"
									className={'searching'} />
							<button type="submit"><Icon icon='search' /></button>
						</form>
					</div>
				</div>
				<div className="clearfix" />
				<div className="col-xs-12 ptop30">
					{ this.props.search.fetching.content 
						? <TextLoader />
						: this.state.searched 
							? articles.length > 0
								? <div>
									{ articles.slice(0, split).map(this.resultRow) }
									{ this.props.search.interests.length > 0 &&
										<div>
											<div className="clearfix" />
											{ this.divider('Recommended Interests') }
											<Interests dispatch={this.props.dispatch} userInterests={this.props.session.interests} interests={this.props.search.interests} />
											<div className="clearfix mtop20" />
										</div>
									}
									{ this.divider('More Results') }
									{ articles.slice(split, articles.length).map(this.resultRow) }
								</div>
								: <p className="text-center mbot50">No results! Search again</p>
							: <p className="text-center mbot50">Search for some content</p>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	search: state.search,
	session: state.session,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getMainSearchContent
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(Search);


// WEBPACK FOOTER //
// ./src/js/views/Search/index.jsx